<template>
  <footer class="footer">
    &copy; 2025 Pawsitive – Supporting SDG 15 | Powered by Logic Loop (TA22)
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background-color: var(--primary);
  color: white;
  text-align: center;
  padding: 1.5rem;
  margin-top: auto;
  position: relative;
  width: 100%;
  font-size: 1rem;
  font-weight: 500;
}
</style> 